import { Reveal, Overline } from "@/components/Reveal";
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="relative bg-[var(--muted)]/60 py-24 md:py-32">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-6 md:px-12 lg:grid-cols-[0.8fr_1.2fr]">
        <Reveal>
          <Overline>FAQ</Overline>
          <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-tight text-[var(--ink)] sm:text-5xl">
            Questions, answered.
          </h2>
          <p className="mt-5 max-w-sm text-sm text-[var(--ink-soft)]">
            Still unsure? Call us at{" "}
            <a href="tel:7676011496" className="font-semibold text-[var(--green)]">7676011496</a>{" "}
            and we’ll help you place a wholesale order.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[var(--border)]">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-display text-lg font-semibold text-[var(--ink)] hover:no-underline hover:text-[var(--green)] md:text-xl"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-[15px] leading-relaxed text-[var(--ink-soft)]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
